import isEqual from 'lodash-es/isEqual';

import { getDecodedJwt } from '@/utils/getDecodedJwt';

export function isSameUser(user: Foxkit.UserCookie, newUser?: Foxkit.UserCookie): boolean {
  const decodedUserToken = getDecodedJwt(user.accessToken);
  const decodedNewUserToken = getDecodedJwt(newUser?.accessToken);

  let equal = isEqual(decodedUserToken, decodedNewUserToken);

  if (user.email !== newUser?.email) {
    equal = false;
  }

  return equal;
}
